import { render, staticRenderFns } from "./SidebarNew.vue?vue&type=template&id=0dfde007&scoped=true"
import script from "./SidebarNew.vue?vue&type=script&lang=js"
export * from "./SidebarNew.vue?vue&type=script&lang=js"
import style0 from "./SidebarNew.vue?vue&type=style&index=0&id=0dfde007&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfde007",
  null
  
)

export default component.exports